export default "__VITE_ASSET__Ca_lUPMM__"